// Fields, defaults, and library info for this section. The editor builds its form from `fields`.
const definition = {
  order: 40,
  type: "collection_list",
  name: "Collection List",
  category: "Navigation",
  description: "Visual grid or scrollable pills of store product categories",
  defaultSettings: {
    title: "Shop by Category",
    subtitle: "Explore our curated departments and find exactly what you need",
    columns: 4,
    columnsTablet: 3,
    columnsMobile: 2,
    categoryCount: 8,
    layout: "grid-4",
    showItemCount: true,
  },
  fields: [
    { key: "title", label: "Section Heading", type: "text" },
    { key: "subtitle", label: "Section Subtitle", type: "text" },
    {
      key: "categoryCount",
      label: "Categories to show",
      type: "select",
      options: [
        { value: 4, label: "4 Categories" },
        { value: 6, label: "6 Categories" },
        { value: 8, label: "8 Categories" },
        { value: 12, label: "12 Categories" },
        { value: 16, label: "16 Categories" },
        { value: 0, label: "All categories" },
      ],
    },
    {
      key: "layout",
      label: "Category Display Layout",
      type: "select",
      options: [
        { value: "grid-4", label: "Visual 4-Column Grid" },
        { value: "tiles", label: "Simple tiles" },
        { value: "pills-scroll", label: "Horizontal Scrollable Chips" },
        { value: "card-grid", label: "Department Cards with Badges" },
      ],
    },
    {
      key: "columns",
      label: "Grid Columns (Desktop)",
      type: "select",
      options: [
        { value: 2, label: "2 Columns" },
        { value: 3, label: "3 Columns" },
        { value: 4, label: "4 Columns" },
        { value: 5, label: "5 Columns" },
        { value: 6, label: "6 Columns" },
      ],
    },
    {
      key: "columnsTablet",
      label: "Grid Columns (Tablet)",
      type: "select",
      options: [
        { value: 2, label: "2 Columns" },
        { value: 3, label: "3 Columns" },
        { value: 4, label: "4 Columns" },
      ],
    },
    {
      key: "columnsMobile",
      label: "Grid Columns (Mobile)",
      type: "select",
      options: [
        { value: 1, label: "1 Column" },
        { value: 2, label: "2 Columns" },
      ],
    },
    { key: "showItemCount", label: "Show Item Count Pill", type: "toggle" },
  ],
};

export default definition;
